import Color from "color";

// https://github.com/Qix-/color/blob/e188999dee229c902102ec37e398ff4d868616e5/index.js#L298
export const isDark = (color: InstanceType<typeof Color>, threshold = 145) => {
  const [r = 0, g = 0, b = 0] = color.rgb().array();
  const yiq = (r * 2126 + g * 7152 + b * 722) / 10000;
  return yiq < threshold;
};

export const loadGoogleFont = (
  fontFamily: string,
  weights: number[] = [400, 500, 600, 700],
) => {
  const fontId = `google-font-${fontFamily.replace(/\s+/g, "-")}`;

  // Prevent duplicate loads
  // Ensure that the html template sets the id of the main font on its link tag (e.g., id="google-font-Inter") to avoid double loading
  // Currently our preferred font is Inter
  if (document.getElementById(fontId)) return;

  const link = document.createElement("link");
  link.id = fontId;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(
    /\s+/g,
    "+",
  )}:wght@${weights.join(";")}&display=swap`;
  document.head.appendChild(link);
};
